// extracted by mini-css-extract-plugin
module.exports = {"historyWrapper":"historyWrapper--1oaay","history":"history--3-fnN","loaderWrapper":"loaderWrapper--3-hBT","loader":"loader--3t6rB","ui":"ui--1H9oo"};